/* RESPONSIBLE TEAM: team-app-security */

export enum ScimGroupState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

// Re-export Ember Data models as types
export type ScimGroup = import('embercom/models/scim-group').default;
export type ScimUser = import('embercom/models/scim-user').default;
export type Role = import('embercom/models/role').default;

export interface Teammate {
  id: string;
  name: string;
  email: string;
}

export interface ScimArgs {
  roles: Role[];
  teammates?: Teammate[];
  canEditScim?: boolean;
}

export interface TableColumn {
  label: string;
  valuePath: string;
  sortable: boolean;
  hasTooltipBlock?: boolean;
}

export interface DropdownItem {
  text: string;
  value?: string;
  onSelectItem: () => void;
}

export interface DropdownGroup {
  items: DropdownItem[];
}

export interface PendingChange {
  type: 'order' | 'role';
  id: number | string;
  title: string;
  oldValue: string;
  newValue: string;
  included: boolean;
}

export interface GroupChanges {
  [groupId: string]: { role_id: number | null };
}

export interface UserGroupMembership {
  id: number;
  name: string;
  priority?: number;
}
